module.exports = __webpack_public_path__ + "img/brushes-jp-2.4af3a73.jpg";